import type React from "react";
import { useEffect, useState } from "react";
import type { TabsProps } from "./types";
import "./styles.css";

const Tabs: React.FC<TabsProps> = ({ selected = 1, tabsContent }): JSX.Element => {
  const [activeTab, setActiveTab] = useState(selected);

  useEffect(() => {
    setActiveTab(selected);
  }, [selected]);

  const handleTabClick = (index: number): void => {
    setActiveTab(index);
  };

  return (
    <div className="tabs-container">
      <div className="tabs-header">
        {tabsContent.map((child) => {
          return (
            <button
              key={child.key}
              className={`tab-button ${activeTab === child.key ? "active" : ""}`}
              onClick={() => handleTabClick(child.key)}
            >
              {child.label}
            </button>
          );
        })}
      </div>
      <div className="tabs-content">
        {tabsContent.find((child) => child.key === activeTab)?.content}
      </div>
    </div>
  );
};

export default Tabs;
